var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59992 0.900391C1.60197 0.900391 0 2.50236 0 4.50031V22.4999C0 23.4547 0.379276 24.3703 1.05439 25.0454C1.72951 25.7206 2.64516 26.0998 3.59992 26.0998H17.9996V35.0996L23.3995 29.6998L28.7994 35.0996V26.0998H32.3993C33.3541 26.0998 34.2697 25.7206 34.9448 25.0454C35.6199 24.3703 35.9992 23.4547 35.9992 22.4999V4.50031C35.9992 3.54555 35.6199 2.6299 34.9448 1.95478C34.2697 1.27967 33.3541 0.900391 32.3993 0.900391H3.59992ZM17.9996 4.50031L23.3995 8.10023L28.7994 4.50031V10.8002L34.1993 13.5001L28.7994 16.2001V22.4999L23.3995 18.9L17.9996 22.4999V16.2001L12.5997 13.5001L17.9996 10.8002V4.50031ZM3.59992 4.50031H12.5997V8.10023H3.59992V4.50031ZM3.59992 11.7002H8.9998V15.3001H3.59992V11.7002ZM3.59992 18.9H12.5997V22.4999H3.59992V18.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfes);
export default __webpack_public_path__ + "static/media/profes.6f47e4ec03c11c8ff8fb894bb77c7b9a.svg";
export { ForwardRef as ReactComponent };